import React, { useEffect, useState } from "react";
import { Accordion, Button, Col, Container, Form, Modal, ModalBody, ModalHeader, Row, Tab, Tabs } from "react-bootstrap";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import styles from "./config.modules.css";

import axios from "axios";
// import ImageUploader from "../../Components/ImageUploader/ImageUploader";
import { useSelector } from "react-redux";
import { faClose, faArrowUp, faArrowDown, faGripVertical } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import ImageUploader from "./ImageUploader";

const HomePageConfigurations = () => {
  const getMinImages = (bannerId) => {
    return bannerId === "plp_Carousal" ? 2 : bannerId === "authorized_products_banner" ? 2 : 1;
  };

  const getMaxImages = (bannerId) => {
    return bannerId === "authorized_products_banner" ? 2 : bannerId === "triple_grid_banner" ? 3 : bannerId === "plp_Carousal" ? 6 : bannerId === "main_banner" || bannerId === "carousal_2" || bannerId === "carousal_1" || bannerId === "mobile_banner" ? 5 : 1;
  };

  const [show, setShow] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [selectedBannedID, setSelectedBannedID] = useState(null);
  const [link, setLink] = useState([]);
  const { user } = useSelector((state) => state.auth);
  const [banner, setBanner] = useState({});
  const [mode, setMode] = useState("add");
  const [page, setPage] = useState("home");
  const [draggedIndex, setDraggedIndex] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadProgress, setUploadProgress] = useState(0);
  const [mobileActiveIndex, setMobileActiveIndex] = useState(0);

  useEffect(() => {
    getBannerByPage();
  }, [page, show]);

  useEffect(() => {
    if (selectedFiles.length > 0 && !isUploading) {
      UploadImage();
    }
  }, [selectedFiles]);

  useEffect(() => {
    fetchBannersByLocation();
  }, [show]);

  useEffect(() => {
    if (banner?.mobile_banner?.length) {
      setMobileActiveIndex(0);
    }
  }, [banner?.mobile_banner?.length]);

  const urlRegex = /\b(?:https?:\/\/(?:www\.)?(?:localhost:3000|staging\.techbazaar\.pk|uat\.techbazaar\.pk|techbazaar\.pk))\b/;

  function validateURL(url) {
    return urlRegex.test(url);
  }

  const handleClick = (e, mode) => {
    e.preventDefault();
    setLink([]);
    setSelectedBannedID([]);
    // console.log(e.currentTarget.closest('#main_banner').getAttribute('page'));

    const bannerId = e.currentTarget.dataset.bannerId || e.currentTarget.closest("[data-banner-id]")?.dataset.bannerId || e.currentTarget.closest("[id]")?.id || e.target.closest("[id]")?.id;
    const pageName = e.currentTarget.dataset.page || e.currentTarget.closest("[page]")?.getAttribute("page") || e.target.closest("[page]")?.getAttribute("page");

    setSelectedBannedID(bannerId);
    setPage(pageName);

    setMode(mode);

    setShow(true);
  };

  const getBannerByPage = async () => {
    try {
      await axios
        .get(`${process.env.REACT_APP_API_URL}/marketplace/banners/${page}`, { withCredentials: true })
        .then((res) => {
          setBanner(res.data.success.data.banners);
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const UploadImage = async () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      return; // Don't throw error, just return silently
    }

    const formData = new FormData();

    // Validate and append files to formData
    selectedFiles.forEach((file) => {
      if (!selectedBannedID || !file?.data) {
        console.error("Invalid file data or selectedBannedID is undefined.");
        return;
      }
      formData.append(selectedBannedID, file.data);
    });

    // Append static links payload
    const linksPayload = { main_banner: {}, category_A: {}, category_B: {}, main_sub_banner: {}, discover_more: {}, authorized_products_banner: {}, carousal_1: {}, triple_grid_banner: {}, carousal_2: {}, mobile_banner: {}, plp_Carousal: {} };
    formData.append("links", JSON.stringify(linksPayload));

    try {
      setIsUploading(true);
      setUploadProgress(0);

      const response = await axios.post(`${process.env.REACT_APP_URL_IMAGE_CDN}/marketplace/home-page-banners`, formData, {
        withCredentials: true,
        headers: {
          "Content-Type": "multipart/form-data",
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
          setUploadProgress(percentCompleted);
        },
      });

      // Extract new links from the API response
      // console.log("Upload response:", response.data);

      const newLinks = response.data.flatMap((data) => {
        // console.log("Processing data:", data);
        return data.images.map((image) => {
          // console.log("Image object:", image);
          // Use the full URL if provided, otherwise use key
          const thumbnail = image.url || image.Location || image.key;
          // console.log("Thumbnail value:", thumbnail);
          return { thumbnail, link: "" };
        });
      });

      // console.log("New links extracted:", newLinks);

      // Filter out duplicates - check if thumbnail already exists in link array
      const existingThumbnails = link.map((item) => item.thumbnail);
      const uniqueNewLinks = newLinks.flat().filter((newLink) => !existingThumbnails.includes(newLink.thumbnail));

      // console.log("Unique new links:", uniqueNewLinks);

      // Only add unique links
      if (uniqueNewLinks.length > 0) {
        setLink([...link, ...uniqueNewLinks]);
      }

      setUploadProgress(100);

      // Clear selected files after successful upload to prevent re-triggering
      setTimeout(() => {
        setSelectedFiles([]);
      }, 500);
    } catch (error) {
      console.error("Error uploading image:", error?.response?.data || error.message);
      setSelectedFiles([]); // Clear on error too
    } finally {
      setIsUploading(false);
      setUploadProgress(0);
    }
  };

  const handleLinkChange = (index, newLink) => {
    if (validateURL(newLink)) {
      const updatedLinks = [...link];
      updatedLinks[index].link = newLink;
      setLink(updatedLinks);
    } else {
      console.error("Invalid URL:", newLink);
    }
  };

  const fetchBannersByLocation = async () => {
    try {
      await axios
        .get(`${process.env.REACT_APP_API_URL}/marketplace/banners/${page}/${selectedBannedID}`, { withCredentials: true })
        .then((res) => {
          setLink(
            res?.data?.success?.data?.map((data, index) => {
              return {
                thumbnail: data.img,
                link: data.link,
              };
            }),
          );
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {}, [link]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (link.length < getMinImages(selectedBannedID)) {
        return;
      }

      const payload = link.map((item, index) => ({
        style: ["main_banner", "authorized_products_banner", "carousal_1", "triple_grid_banner", "carousal_2", "mobile_banner", "plp_Carousal"].includes(selectedBannedID) ? "carousel" : "single",
        page: page,
        location: selectedBannedID,
        link: item.link || "",
        sequence: index,
        expires_on: null,
        uploaded_by: user?.user_id,
        created_at: Date.UTC(),
        updated_at: null,
        is_deleted: false,
        img: item.thumbnail,
        is_mobile_banner: selectedBannedID === "mobile_banner",
      }));

      // console.log(payload, 'payload');

      if (mode === "add") {
        const response = await axios
          .post(`${process.env.REACT_APP_API_URL}/marketplace/banners`, payload, {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            setShow(false);
            setSelectedFiles([]);
            setLink([]);
            getBannerByPage();
          });
      } else if (mode === "edit") {
        const response = await axios
          .patch(`${process.env.REACT_APP_API_URL}/marketplace/banners/${page}/${selectedBannedID}`, payload, {
            withCredentials: true,
            headers: {
              "Content-Type": "application/json",
            },
          })
          .then((res) => {
            setShow(false);
          });
      }
    } catch (error) {
      console.error("Error saving data:", error);
    }
  };
  const onDelete = async (itemToDelete) => {
    setLink((prevLinks) => prevLinks.filter((item) => item !== itemToDelete));
    await axios.post(
      `${process.env.REACT_APP_URL_IMAGE_CDN}/delete`,
      {
        files: [itemToDelete.thumbnail],
      },
      { withCredentials: true },
    );
  };

  const moveItem = (index, direction) => {
    const newIndex = direction === "up" ? index - 1 : index + 1;
    if (newIndex < 0 || newIndex >= link.length) {
      return;
    }

    const items = Array.from(link);
    const [movedItem] = items.splice(index, 1);
    items.splice(newIndex, 0, movedItem);

    setLink(items);
  };

  const handleDragStart = (e, index) => {
    setDraggedIndex(index);
    e.dataTransfer.effectAllowed = "move";
    e.dataTransfer.setData("text/html", e.currentTarget);
  };

  const handleDragOver = (e, index) => {
    e.preventDefault();
    if (draggedIndex === null || draggedIndex === index) {
      return;
    }

    const items = Array.from(link);
    const draggedItem = items[draggedIndex];

    items.splice(draggedIndex, 1);
    items.splice(index, 0, draggedItem);

    setLink(items);
    setDraggedIndex(index);
  };

  const handleDragEnd = () => {
    setDraggedIndex(null);
  };

  // Carousel Configuration
  const CAROUSEL_CONFIG = {
    standard: {
      dots: true,
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: false,
      arrows: true,
    },
    mobile: {
      dots: false,
      infinite: true,
      speed: 500,
      slidesToShow: 3,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 2000,
      pauseOnHover: false,
      arrows: true,
      centerMode: true,
      centerPadding: "20px",
      focusOnSelect: true,
      beforeChange: (_, next) => setMobileActiveIndex(next),
      responsive: [
        { breakpoint: 992, settings: { slidesToShow: 3, centerPadding: "40px" } },
        { breakpoint: 576, settings: { slidesToShow: 3, centerPadding: "10px", arrows: false } },
      ],
    },
  };

  const GRADIENT_CLASSES = ["mobile-gradient-orange", "mobile-gradient-blue", "mobile-gradient-purple", "mobile-gradient-green"];

  // Helper: Get coverflow position class for mobile slides
  const getMobileSlideClass = (index, totalSlides) => {
    if (!totalSlides) return "";
    const leftIndex = (mobileActiveIndex - 1 + totalSlides) % totalSlides;
    const rightIndex = (mobileActiveIndex + 1) % totalSlides;
    if (index === mobileActiveIndex) return "mobile-slide-center";
    if (index === leftIndex) return "mobile-slide-left";
    if (index === rightIndex) return "mobile-slide-right";
    return "mobile-slide-back";
  };

  // Render mobile banner slide with gradient wrapper
  const renderMobileSlide = (item, index, altPrefix, totalSlides) => {
    const gradientClass = GRADIENT_CLASSES[index % GRADIENT_CLASSES.length];
    const positionClass = getMobileSlideClass(index, totalSlides);
    return (
      <div key={`${altPrefix}-${index}`} className={`mobile-slide h-100 ${positionClass}`}>
        <div className={`mobile-slide-inner ${gradientClass}`}>
          <img src={`${process.env.REACT_APP_URL_S3}/${item?.img}`} alt={`${altPrefix} ${index + 1}`} className="mobile-slide-image" />
        </div>
      </div>
    );
  };

  // Render standard banner slide
  const renderStandardSlide = (item, index, altPrefix) => (
    <div key={`${altPrefix}-${index}`} className="h-100">
      <img src={`${process.env.REACT_APP_URL_S3}/${item?.img}`} alt={`${altPrefix} ${index + 1}`} className="banner-img" />
    </div>
  );

  const renderAuthorizedProductsContent = (bannerData = []) => {
    const tiles = Array.from({ length: 2 }, (_, index) => bannerData[index] || null);

    return (
      <div className="d-flex w-100 gap-3" style={{ minHeight: "260px" }}>
        {tiles.map((item, index) => (
          <div key={`authorized-products-${index}`} className="position-relative flex-fill overflow-hidden rounded" style={{ height: "260px", background: item ? "transparent" : "#f3f4f6" }}>
            {item ? (
              <>
                <img src={`${process.env.REACT_APP_URL_S3}/${item?.img}`} alt={`authorized_products_banner ${index + 1}`} className="w-100 h-100" style={{ objectFit: "cover" }} />
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Button data-banner-id="authorized_products_banner" data-page="home" onClick={(e) => handleClick(e, "edit")} variant="success">
                    Edit
                  </Button>
                </div>
                <div className="position-absolute bottom-0 start-0 ps-2 text-white fw-bold fs-12" style={{ background: "rgba(0, 0, 0, 0.35)", width: "100%" }}>
                  1128 x 755
                </div>
              </>
            ) : (
              <div id="authorized_products_banner" className="w-100 h-100 skeleton btn_hover" page="home">
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Button data-banner-id="authorized_products_banner" data-page="home" onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                    Add +
                  </Button>
                </div>
                <div className="position-absolute bottom-0 start-0 ps-2 text-muted fw-bold fs-12" style={{ width: "100%" }}>
                  1128 x 755
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  const renderTripleGridContent = (bannerData = []) => {
    const tiles = Array.from({ length: 3 }, (_, index) => bannerData[index] || null);

    return (
      <div className="d-flex w-100 gap-3" style={{ minHeight: "260px" }}>
        {tiles.map((item, index) => (
          <div key={`triple-grid-${index}`} className="position-relative flex-fill overflow-hidden rounded" style={{ height: "260px", background: item ? "transparent" : "#f3f4f6" }}>
            {item ? (
              <>
                <img src={`${process.env.REACT_APP_URL_S3}/${item?.img}`} alt={`triple_grid_banner ${index + 1}`} className="w-100 h-100" style={{ objectFit: "cover" }} />
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Button data-banner-id="triple_grid_banner" data-page="home" onClick={(e) => handleClick(e, "edit")} variant="success">
                    Edit
                  </Button>
                </div>
                <div className="position-absolute bottom-0 start-0 ps-2 text-white fw-bold fs-12" style={{ background: "rgba(0, 0, 0, 0.35)", width: "100%" }}>
                  350x450
                </div>
              </>
            ) : (
              <div id="triple_grid_banner" className="w-100 h-100 skeleton btn_hover" page="home">
                <div className="position-absolute top-50 start-50 translate-middle">
                  <Button data-banner-id="triple_grid_banner" data-page="home" onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                    Add +
                  </Button>
                </div>
                <div className="position-absolute bottom-0 start-0 ps-2 text-muted fw-bold fs-12" style={{ width: "100%" }}>
                  350x450
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    );
  };

  // Main banner content renderer
  const renderBannerContent = (bannerData, altPrefix = "banner") => {
    if (!bannerData?.length) return null;

    const isMobileBanner = altPrefix === "mobile_banner";
    const isMultiple = bannerData.length > 1;

    // Single image rendering
    if (!isMultiple) {
      const singleImage = <img src={`${process.env.REACT_APP_URL_S3}/${bannerData[0]?.img}`} alt={altPrefix} className={isMobileBanner ? "mobile-slide-image" : "banner-img"} />;
      return isMobileBanner ? (
        <div className="mobile-slide h-100">
          <div className="mobile-slide-inner mobile-gradient-orange">{singleImage}</div>
        </div>
      ) : (
        singleImage
      );
    }

    // Multiple images - carousel rendering
    const settings = isMobileBanner ? CAROUSEL_CONFIG.mobile : CAROUSEL_CONFIG.standard;
    const sliderClassName = isMobileBanner ? "mobile-slider h-100" : "h-100";

    return (
      <Slider {...settings} className={sliderClassName}>
        {bannerData.map((item, index) => (isMobileBanner ? renderMobileSlide(item, index, altPrefix, bannerData.length) : renderStandardSlide(item, index, altPrefix)))}
      </Slider>
    );
  };

  return (
    <>
      <Container fluid>
        <Tabs defaultActiveKey="home" id="uncontrolled-tab-example" className="mb-3" onSelect={(key) => setPage(key === "plp" ? "plp" : "home")}>
          <Tab eventKey="home" title="Home">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0" onClick={() => setPage("home")}>
                <Accordion.Header>Top Banner</Accordion.Header>
                <Accordion.Body className="">
                  <div className="grid_container">
                    {banner?.main_banner?.length >= 1 ? (
                      <>
                        <div id="main_banner" className="btn_hover" page="home">
                          {renderBannerContent(banner?.main_banner, "main_banner")}
                          <div className="d-flex align-center button-container">
                            <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                              Edit
                            </Button>
                          </div>
                          <div className="position-absolute  bottom-0 ps-2 text-muted fw-bold fs-12">700 x 300</div>
                        </div>
                      </>
                    ) : (
                      <div className=" skeleton btn_hover" id="main_banner" page="home">
                        <div className="d-flex align-center button-container">
                          <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                            Add +
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">700 x 300</div>
                      </div>
                    )}

                    {/* {banner?.category_A?.length >= 1 ? (
                      <>
                        <div id="category_A" className="btn_hover" page="home">
                          <img src={`${process.env.REACT_APP_URL_S3}/${banner?.category_A[0]?.img}`} alt="main banner" className="banner-img" />
                          <div className="d-flex align-center button-container" page="home">
                            <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                              Edit
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">250 x 150</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="  skeleton btn_hover " id="category_A" page="home">
                          <div className="d-flex align-center button-container ">
                            <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                              Add +
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">250 x 150</div>
                        </div>
                      </>
                    )}

                    {banner?.category_B?.length >= 1 ? (
                      <>
                        <div className="btn_hover" id="category_B" page="home">
                          <img src={`${process.env.REACT_APP_URL_S3}/${banner?.category_B[0]?.img}`} alt="main banner" className="banner-img" />
                          <div className="d-flex align-center button-container">
                            <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                              Edit
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">250 x 150</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="skeleton btn_hover " id="category_B" page="home">
                          <div className="d-flex align-center button-container ">
                            <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                              Add +
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">250 x 150</div>
                        </div>
                      </>
                    )} */}

                    {/* {banner?.main_sub_banner?.length >= 1 ? (
                      <>
                        <div className="btn_hover" id="main_sub_banner" page="home">
                          <img src={`${process.env.REACT_APP_URL_S3}/${banner?.main_sub_banner[0]?.img}`} alt="main banner" className="banner-img" />
                          <div className="d-flex align-center button-container">
                            <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                              Edit
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">450 x 200</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="skeleton btn_hover " id="main_sub_banner" page="home">
                          <div className="d-flex align-center button-container ">
                            <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                              Add +
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">450 x 200</div>
                        </div>
                      </>
                    )}

                    {banner?.discover_more?.length >= 1 ? (
                      <>
                        <div className="btn_hover" id="discover_more" page="home">
                          <img src={`${process.env.REACT_APP_URL_S3}/${banner?.discover_more[0]?.img}`} alt="main banner" className="banner-img" />
                          <div className="d-flex align-center button-container">
                            <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                              Edit
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12 ">450 x 100</div>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className=" skeleton btn_hover " id="discover_more" page="home">
                          <div className="d-flex align-center button-container ">
                            <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                              Add +
                            </Button>
                          </div>
                          <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">450 x 100</div>
                        </div>
                      </>
                    )} */}
                  </div>
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="1" className="mt-3" onClick={() => setPage("home")}>
                <Accordion.Header>Authorized Products Banner</Accordion.Header>
                <Accordion.Body className="d-flex justify-content-center">{renderAuthorizedProductsContent(banner?.authorized_products_banner || [])}</Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="2" className="mt-3" onClick={() => setPage("home")}>
                <Accordion.Header>Carousal 1</Accordion.Header>
                <Accordion.Body>
                  {banner?.carousal_1?.length ? (
                    <>
                      <div id="carousal_1" className="w-100 btn_hover" page="home" style={{ height: "200px" }}>
                        {renderBannerContent(banner?.carousal_1, "carousal_1")}
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                            Edit
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div id="carousal_1" className="w-100 skeleton btn_hover" page="home" style={{ height: "200px" }}>
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                            Add +
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="3" className="mt-3" onClick={() => setPage("home")}>
                <Accordion.Header>Triple Grid Banner</Accordion.Header>
                <Accordion.Body className="d-flex justify-content-center">{renderTripleGridContent(banner?.triple_grid_banner || [])}</Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="4" className="mt-3" onClick={() => setPage("home")}>
                <Accordion.Header>Carousal 2</Accordion.Header>
                <Accordion.Body>
                  {banner?.carousal_2?.length ? (
                    <>
                      <div id="carousal_2" className="w-100 btn_hover" page="home" style={{ height: "200px" }}>
                        {renderBannerContent(banner?.carousal_2, "carousal_2")}
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                            Edit
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div id="carousal_2" className="w-100 skeleton btn_hover" page="home" style={{ height: "200px" }}>
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                            Add +
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>

              <Accordion.Item eventKey="5" className="mt-3" onClick={() => setPage("home")}>
                <Accordion.Header>Mobile Banner</Accordion.Header>
                <Accordion.Body className="d-flex justify-content-center">
                  {banner?.mobile_banner?.length ? (
                    <>
                      <div id="mobile_banner" className="btn_hover" page="home" style={{ width: "660px", height: "250px" }}>
                        {renderBannerContent(banner?.mobile_banner, "mobile_banner")}
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                            Edit
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">200x250</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div id="mobile_banner" className="skeleton btn_hover" page="home" style={{ width: "660px", height: "250px" }}>
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                            Add +
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">200x250</div>
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Tab>
          <Tab eventKey="plp" title="PLP">
            <Accordion defaultActiveKey="0">
              <Accordion.Item eventKey="0" className="mt-3" onClick={() => setPage("plp")}>
                <Accordion.Header>PLP Carousal</Accordion.Header>
                <Accordion.Body>
                  {banner?.plp_Carousal?.length ? (
                    <>
                      <div id="plp_Carousal" className="w-100 btn_hover" page="plp" style={{ height: "200px" }}>
                        {renderBannerContent(banner?.plp_Carousal, "plp_carousal")}
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "edit")} variant="success">
                            Edit
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  ) : (
                    <>
                      <div id="plp_Carousal" className="w-100 skeleton btn_hover" page="plp" style={{ height: "200px" }}>
                        <div className="button-container">
                          <Button onClick={(e) => handleClick(e, "add")} variant="outline-primary">
                            Add +
                          </Button>
                        </div>
                        <div className="position-absolute bottom-0 ps-2 text-muted fw-bold fs-12">1500x200</div>
                      </div>
                    </>
                  )}
                </Accordion.Body>
              </Accordion.Item>
            </Accordion>
          </Tab>

          <Tab className="text-muted" eventKey="category" title="Category" disabled></Tab>
          <Tab className="text-muted" eventKey="shop" title="Shop" disabled></Tab>
          <Tab className="text-muted" eventKey="pdp" title="PDP" disabled></Tab>
          <Tab className="text-muted" eventKey="other" title="Other" disabled></Tab>
        </Tabs>
      </Container>

      <Modal
        centered
        size="lg"
        show={show}
        onHide={() => {
          setShow(false);
          setSelectedFiles([]);
          setLink([]);
          getBannerByPage();
        }}
      >
        <Modal.Header closeButton>
          {" "}
          <Modal.Title>Upload Image</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ImageUploader selectedFiles={selectedFiles} setSelectedFiles={setSelectedFiles} numberOfImages={getMaxImages(selectedBannedID)} currentImageCount={link.length + selectedFiles.length} />

          {/* Upload Progress */}
          {isUploading && (
            <div className="mt-3 mb-3">
              <div className="d-flex justify-content-between mb-1">
                <span className="text-muted small">Uploading images...</span>
                <span className="text-muted small">{uploadProgress}%</span>
              </div>
              <div className="progress" style={{ height: "8px" }}>
                <div className="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" style={{ width: `${uploadProgress}%` }} aria-valuenow={uploadProgress} aria-valuemin="0" aria-valuemax="100" />
              </div>
            </div>
          )}
          <Form onSubmit={handleSubmit}>
            {link?.length > 0 && (
              <div className="mb-3">
                {link.map((item, index) => (
                  <div
                    key={item.thumbnail}
                    className="d-flex align-items-center my-2 p-2 border rounded"
                    draggable
                    onDragStart={(e) => handleDragStart(e, index)}
                    onDragOver={(e) => handleDragOver(e, index)}
                    onDragEnd={handleDragEnd}
                    style={{
                      backgroundColor: draggedIndex === index ? "#e9ecef" : "white",
                      cursor: "move",
                      opacity: draggedIndex === index ? 0.5 : 1,
                      transition: "all 0.2s ease",
                    }}
                  >
                    {/* Drag Handle */}
                    <div className="me-2" style={{ cursor: "grab" }}>
                      <FontAwesomeIcon icon={faGripVertical} className="text-muted" />
                    </div>

                    {/* Up/Down Buttons */}
                    <div className="d-flex flex-column me-2">
                      <Button size="sm" variant="outline-secondary" disabled={index === 0} onClick={() => moveItem(index, "up")} style={{ padding: "2px 8px", marginBottom: "2px", fontSize: "10px" }}>
                        <FontAwesomeIcon icon={faArrowUp} />
                      </Button>
                      <Button size="sm" variant="outline-secondary" disabled={index === link.length - 1} onClick={() => moveItem(index, "down")} style={{ padding: "2px 8px", fontSize: "10px" }}>
                        <FontAwesomeIcon icon={faArrowDown} />
                      </Button>
                    </div>

                    {/* Order Number */}
                    <div className="me-2 fw-bold text-center" style={{ minWidth: "30px" }}>
                      {index + 1}
                    </div>

                    {/* Thumbnail */}
                    <div className="me-2" style={{ width: "100px", height: "50px" }}>
                      <img src={`${process.env.REACT_APP_URL_S3}/${item.thumbnail}`} alt="thumbnail" style={{ objectFit: "contain", width: "100%", height: "100%" }} />
                    </div>

                    {/* Link Input */}
                    <Form.Control className="ms-2" placeholder="Link" value={item.link} onChange={(e) => handleLinkChange(index, e.target.value)} />

                    {/* Delete Button */}
                    <FontAwesomeIcon icon={faClose} alt="close" className="ms-2" style={{ cursor: "pointer", color: "#dc3545" }} onClick={() => onDelete(item)} />
                  </div>
                ))}
              </div>
            )}

            <div className="d-flex justify-content-center my-2">
              <Button type="submit" disabled={link.length < getMinImages(selectedBannedID) || isUploading}>
                {isUploading ? "Uploading..." : "Save"}
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default HomePageConfigurations;
